import { Box, Typography } from '@mui/material';
import { userTypeSelector } from '../../redux/selectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { validateAuth, getApiBaseUrl } from '../../util/util';
import axios from 'axios';
import moment from 'moment-timezone';

function TopBanner({ bannerVariant }) {
  const [bannerMessage, setBannerMessage] = useState('');
  const [bannerType, setBannerType] = useState('warning');
  const currentUserType = useSelector(userTypeSelector);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (currentUserType.type == 'internal') {
      setBannerMessage('Please Note - You are logged in as an internal user.');
      setBannerType('warning');
      setHidden(false);
    } else {
      fetchMaintenanceBanner().then((data) => {
        const banner = data?.data?.banner;
        if (!banner) {
          setHidden(true);
          return;
        }
        setHidden(
          !banner.enabled ||
            (banner.start_date && moment().isBefore(banner.start_date)) ||
            (banner.end_date && moment().isAfter(banner.end_date))
        );
        setBannerType('maintenance');
        setBannerMessage(banner.message || '');
      });
    }
  }, [currentUserType]);

  // Determine background and font colors based on banner type
  const { bg, fg } =
    bannerType === 'warning'
      ? { bg: 'lightwarning.main', fg: 'lightwarning.contrastText' }
      : { bg: 'accent3.main', fg: 'accent3.contrastText' };

  // Get the appropriate styles based on the banner variant
  const { margin, maxWidth } =
    bannerVariant === 'dashboard'
      ? { margin: '0', maxWidth: '100%' }
      : bannerVariant === 'DF'
        ? { margin: '32px auto 0px auto', maxWidth: '1024px' }
        : { margin: '32px auto 0px auto', maxWidth: '832px' };

  const fetchMaintenanceBanner = () => {
    return new Promise((resolve, reject) => {
      validateAuth(
        (session) => {
          axios
            .get(`${getApiBaseUrl(currentUserType.type)}/admin_settings/maintenance_banner`, {
              headers: {
                Authorization: session.getIdToken().getJwtToken(),
              },
              timeout: 15 * 1000,
            })
            .then(resolve)
            .catch((error) => {
              setHidden(true);
              reject(error);
            });
        },
        (error) => reject(error)
      );
    });
  };

  if (hidden && bannerVariant == 'dashboard') return null;
  else if (hidden && (bannerVariant === 'DF' || bannerVariant === 'requestPage'))
    return <Box sx={{ height: '16px' }}></Box>;
  else
    return (
      <Box
        sx={{
          display: hidden ? 'none' : 'flex',
          width: '100%',
          borderRadius: 2,
          height: '32px',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: bg,
          margin: margin,
          maxWidth: maxWidth,
        }}
      >
        <Typography
          sx={{
            textAlign: 'center',
            width: '100%',
            color: fg,
            fontSize: '0.825rem',
            fontWeight: 500,
          }}
        >
          {bannerMessage}
        </Typography>
      </Box>
    );
}

export default TopBanner;
